import "./App.css";

function ProcessScreen() {
  return (
    <div className="box companygrid">
      {/* <div>No. of Company</div> <input type="text" style={{ width: "50px" }} />{" "}
      <div> No. of Gateways</div>
      <input type="text" style={{ width: "50px" }} />{" "}
      <div> No. of Application</div>{" "}
      <input type="text" style={{ width: "50px" }} />
      <div>No. of Threads Parameter</div>{" "}
      <input type="text" style={{ width: "50px" }} />
      <div>No. of Parameter</div>{" "}
      <input type="text" style={{ width: "50px" }} /> */}
      <div>
        <button> Start </button>
      </div>{" "}
      <input type="text" style={{ width: "50px" }} />
      <div>
        <button> Stop </button>
      </div>{" "}
      <input type="text" style={{ width: "50px" }} />
    </div>
  );
}

export default ProcessScreen;
